<template>
  <section
    v-if="cardProfile"
    class="user-card"
    :class="`user-card--${cardProfile.level}`"
  >
    <div class="header">
      <p class="title">{{ cardProfile.title }}</p>
      <p class="bonus">全网权益:{{ cardProfile.bonusRange }}</p>
    </div>
    <div v-if="cardProfile.cards.length" class="card-list">
      <div
        v-for="card in cardProfile.cards"
        :key="card.tokenId"
        class="card-item"
      >
        <img :src="card.image" alt="卡牌" class="card-thumb" />
        <span
          class="card-badge"
          :class="card.activated ? 'card-badge--active' : 'card-badge--inactive'"
        >
          {{ card.activated ? "已激活" : "未激活" }}
        </span>
      </div>
    </div>
    <div v-if="cardProfile.hasUnactivated" class="footer">
      <button
        class="activate-btn"
        :disabled="activating"
        @click="$emit('activate')"
      >
        {{ activating ? "激活中..." : "激活" }}
      </button>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { fetchRadUserCardProfile } from "@/contract/services/radStakeService";

export default {
  props: {
    activating: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cardProfile: null,
    };
  },
  computed: {
    ...mapGetters(["accountAddress"]),
  },
  watch: {
    accountAddress: {
      immediate: true,
      handler() {
        this.loadCardProfile();
      },
    },
  },
  methods: {
    async loadCardProfile() {
      if (!this.accountAddress) {
        this.cardProfile = null;
        return;
      }
      try {
        this.cardProfile = await fetchRadUserCardProfile(this.accountAddress);
      } catch (err) {
        console.error("[RadUserInfoCard] 加载卡牌信息失败", err);
        this.cardProfile = null;
        throw err;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.user-card {
  margin: 0 30px 24px;
  padding: 20px 30px;
  border-radius: 30px;

  &--gold {
    background: #fead5b;
  }

  &--silver {
    background: #c7c7ff;
  }

  &--bronze {
    background: #f8e6c1;
  }
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;

  .title {
    margin: 0;
    font-size: 30px;
    font-weight: normal;
    color: #000000;
  }

  .bonus {
    margin: 0;
    flex-shrink: 0;
    font-size: 24px;
    color: #000000;
  }
}

.card-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.card-item {
  position: relative;
  width: 120px;
}

.card-thumb {
  display: block;
  width: 120px;
  height: auto;
  border-radius: 8px;
  object-fit: contain;
}

.card-badge {
  position: absolute;
  left: 50%;
  bottom: 8px;
  transform: translateX(-50%);
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 18px;
  line-height: 1.4;
  white-space: nowrap;

  &--active {
    color: #fff;
    background: rgba(115, 56, 255, 0.92);
  }

  &--inactive {
    color: #fff;
    background: rgba(0, 0, 0, 0.55);
  }
}

.footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

.activate-btn {
  padding: 0;
  border: none;
  background: transparent;
  font-size: 26px;
  color: #7338ff;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover:not(:disabled) {
    opacity: 0.85;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
</style>
